import { defineMessages } from 'react-intl';

export const freightFormMessages = defineMessages({
  shipFromLabel: {
    defaultMessage: 'Ship From Location',
    id: 'IKQ7GO',
    description: 'Label for ship from location select',
  },
  shipFromPlaceholder: {
    defaultMessage: 'Select a location',
    id: 'rt/aP4',
    description: 'Placeholder for ship from location select',
  },
  destinationTitle: {
    defaultMessage: 'Ship To',
    id: 'pBmFTb',
    description: 'Title for destination section',
  },
  cityLabel: {
    defaultMessage: 'City',
    id: 'Xw/VVZ',
    description: 'Label for city input',
  },
  stateLabel: {
    defaultMessage: 'State',
    id: 'KILEye',
    description: 'Label for state select',
  },
  statePlaceholder: {
    defaultMessage: 'Select state',
    id: '1h3Ubt',
    description: 'Placeholder for state select',
  },
  postalCodeLabel: {
    defaultMessage: 'Zip Code',
    id: 'iTTcLT',
    description: 'Label for postal code input',
  },
  handlingUnitsTitle: {
    defaultMessage: 'Handling Units',
    id: 'Op5vys',
    description: 'Title for handling units section',
  },
  addUnit: {
    defaultMessage: '+ Add Unit',
    id: 'k3Kg6v',
    description: 'Button to add another handling unit',
  },
  addCommodity: {
    defaultMessage: '+ Add Commodity',
    id: 'W1ReiF',
    description: 'Button to add another commodity to a handling unit',
  },
  unitTypeLabel: {
    defaultMessage: 'Unit Type',
    id: 'a4F3yr',
    description: 'Label for unit type select',
  },
  quantityLabel: {
    defaultMessage: 'Quantity',
    id: 'rOVIqG',
    description: 'Label for quantity input',
  },
  stackableLabel: {
    defaultMessage: 'Stackable',
    id: 'l8CMrC',
    description: 'Label for stackable select',
  },
  stackableYes: {
    defaultMessage: 'Yes',
    id: '37UHDS',
    description: 'Yes option for stackable select',
  },
  stackableNo: {
    defaultMessage: 'No',
    id: 'sX5dEO',
    description: 'No option for stackable select',
  },
  dimensionsLabel: {
    defaultMessage: 'Dimensions ({unit})',
    id: 'Uts/6o',
    description: 'Label for dimensions input with unit of measure',
  },
  commodityTitle: {
    defaultMessage: 'Commodity #{number}',
    id: 'DLFCSH',
    description: 'Title for a commodity card',
  },
  totalWeightLabel: {
    defaultMessage: 'Total Weight',
    id: '41Yarr',
    description: 'Label for total weight input',
  },
  freightClassLabel: {
    defaultMessage: 'Freight Class',
    id: 'hL0pQK',
    description: 'Label for freight class select',
  },
  freightClassPlaceholder: {
    defaultMessage: 'Select class',
    id: '42LL43',
    description: 'Placeholder for freight class select',
  },
  accessorialsTitle: {
    defaultMessage: 'Accessorials',
    id: 'al/dVR',
    description: 'Title for accessorials accordion section',
  },
  insuranceLabel: {
    defaultMessage: 'Insure this shipment',
    id: 'e6cvd3',
    description: 'Checkbox label for insurance',
  },
  conditionOfGoodsLabel: {
    defaultMessage: 'Condition of Goods',
    id: '4Vh+d/',
    description: 'Label for condition of goods dropdown in insurance section',
  },
  categoryLabel: {
    defaultMessage: 'Category',
    id: 'Ib9lLk',
    description: 'Label for category dropdown in insurance section',
  },
  insuredValueLabel: {
    defaultMessage: 'Insured Value',
    id: 'y0K4sI',
    description: 'Label for insured value input in insurance section',
  },
  marksAndNumbersLabel: {
    defaultMessage: 'Marks & Numbers (Optional)',
    id: '32vBWv',
    description: 'Label for marks and numbers input in insurance section',
  },
  selectOnePlaceholder: {
    defaultMessage: 'Select One',
    id: '4zP43z',
    description: 'Placeholder for dropdown selects',
  },
  handlingUnitTitle: {
    defaultMessage: 'Handling Unit #{number}',
    id: 'a6+plh',
    description: 'Title for a handling unit card',
  },
  removeUnit: {
    defaultMessage: 'Remove',
    id: 'eZ6Jum',
    description: 'Button to remove a handling unit',
  },
  removeCommodity: {
    defaultMessage: 'Remove',
    id: '25UtUh',
    description: 'Button to remove a commodity from a handling unit',
  },
  conditionNew: {
    defaultMessage: 'New',
    id: 'Yu11UL',
    description: 'New condition option for insurance condition of goods',
  },
  conditionUsed: {
    defaultMessage: 'Used',
    id: 'DKltpm',
    description: 'Used condition option for insurance condition of goods',
  },
  categoryGeneralMerchandise: {
    defaultMessage: 'General Merchandise',
    id: 'gaUjVh',
    description: 'General Merchandise option for insurance commodity category',
  },
  categoryEquipment: {
    defaultMessage: 'Equipment',
    id: '7gYTGh',
    description: 'Equipment option for insurance commodity category',
  },
  categoryFoodBeverages: {
    defaultMessage: 'Food & Beverages',
    id: '7qKD6m',
    description: 'Food and Beverages option for insurance commodity category',
  },
  categoryChemicalsPaint: {
    defaultMessage: 'Chemicals & Paint',
    id: '34izN7',
    description: 'Chemicals and Paint option for insurance commodity category',
  },
  categoryElectronics: {
    defaultMessage: 'Electronics',
    id: 'xc+s9u',
    description: 'Electronics option for insurance commodity category',
  },
  categoryConstruction: {
    defaultMessage: 'Construction',
    id: '9GaKgj',
    description: 'Construction option for insurance commodity category',
  },
  categoryFurniture: {
    defaultMessage: 'Furniture',
    id: 'HiBVEi',
    description: 'Furniture option for insurance commodity category',
  },
  categoryStonework: {
    defaultMessage: 'Stonework',
    id: 'oBMkeh',
    description: 'Stonework option for insurance commodity category',
  },
  categoryFragileItems: {
    defaultMessage: 'Fragile Items',
    id: 'm03sNK',
    description: 'Fragile Items option for insurance commodity category',
  },
  categoryPerishables: {
    defaultMessage: 'Perishables',
    id: 'B1zflG',
    description: 'Perishables option for insurance commodity category',
  },
  categoryJewelry: {
    defaultMessage: 'Jewelry',
    id: 'Fbhj/F',
    description: 'Jewelry option for insurance commodity category',
  },
  categoryMotorizedTransport: {
    defaultMessage: 'Motorized Transport',
    id: 'LSwBV+',
    description: 'Motorized Transport option for insurance commodity category',
  },
  categoryArtAntiques: {
    defaultMessage: 'Art & Antiques',
    id: '2rHRK7',
    description: 'Art and Antiques option for insurance commodity category',
  },
  categoryExplosives: {
    defaultMessage: 'Explosives',
    id: 'IYf6Lp',
    description: 'Explosives option for insurance commodity category',
  },
  categoryLifeForms: {
    defaultMessage: 'Life Forms',
    id: '4QYCcS',
    description: 'Life Forms option for insurance commodity category',
  },
  categoryControlledItems: {
    defaultMessage: 'Controlled Items',
    id: 'P/Q7CM',
    description: 'Controlled Items option for insurance commodity category',
  },
  categoryPharmaNonRefrigerated: {
    defaultMessage: 'Pharma (Non-Refrigerated)',
    id: 'y8iWhX',
    description: 'Pharma Non-Refrigerated option for insurance commodity category',
  },
  categoryPharmaRefrigerated: {
    defaultMessage: 'Pharma (Refrigerated)',
    id: 'EccQWu',
    description: 'Pharma Refrigerated option for insurance commodity category',
  },
  pickupServicesHeader: {
    defaultMessage: 'Pickup Services',
    id: '5PPmhy',
    description: 'Subheader for the pickup accessorials column',
  },
  deliveryServicesHeader: {
    defaultMessage: 'Delivery Services',
    id: 'ULJA18',
    description: 'Subheader for the delivery accessorials column',
  },
  accessorialInsidePickup: {
    defaultMessage: 'Inside Pickup',
    id: '5Q9qOC',
    description: 'Inside pickup accessorial option',
  },
  accessorialConstructionSitePickup: {
    defaultMessage: 'Construction Site Pickup',
    id: '5jQn/0',
    description: 'Construction site pickup accessorial option',
  },
  accessorialLiftgatePickup: {
    defaultMessage: 'Liftgate Pickup',
    id: '1Cf/jD',
    description: 'Liftgate pickup accessorial option',
  },
  accessorialNotifyBeforePickup: {
    defaultMessage: 'Notify Me Before Pickup',
    id: 'hgzG6Q',
    description: 'Notify before pickup accessorial option',
  },
  accessorialResidentialPickup: {
    defaultMessage: 'Residential Pickup',
    id: 'Xx0mUW',
    description: 'Residential pickup accessorial option',
  },
  accessorialDropShipmentAtTerminal: {
    defaultMessage: 'Drop Shipment at Terminal',
    id: 's7e1kC',
    description: 'Drop shipment at terminal pickup accessorial option',
  },
  accessorialGroceryConsolidationPickup: {
    defaultMessage: 'Grocery Consolidation Pickup',
    id: 'dTFCjm',
    description: 'Grocery consolidation pickup accessorial option',
  },
  accessorialLimitedAccess: {
    defaultMessage: 'Limited Access',
    id: 'PlhkBM',
    description: 'Limited access accessorial option (pickup and delivery)',
  },
  accessorialTradeshowPickup: {
    defaultMessage: 'Tradeshow Pickup',
    id: 'hzTx0x',
    description: 'Tradeshow pickup accessorial option',
  },
  accessorialInsideDelivery: {
    defaultMessage: 'Inside Delivery',
    id: 'xy6FiW',
    description: 'Inside delivery accessorial option',
  },
  accessorialConstructionSiteDelivery: {
    defaultMessage: 'Construction Site Delivery',
    id: '5l6Rqt',
    description: 'Construction site delivery accessorial option',
  },
  accessorialLiftgateDelivery: {
    defaultMessage: 'Liftgate Delivery',
    id: 'PUtGHy',
    description: 'Liftgate delivery accessorial option',
  },
  accessorialNotifyBeforeDelivery: {
    defaultMessage: 'Notify Me Before Delivery',
    id: 'uXzzDS',
    description: 'Notify before delivery accessorial option',
  },
  accessorialResidentialDelivery: {
    defaultMessage: 'Residential Delivery',
    id: 'ec0jBt',
    description: 'Residential delivery accessorial option',
  },
  accessorialHoldShipmentAtTerminal: {
    defaultMessage: 'Hold Shipment at Terminal',
    id: 'Pa01xY',
    description: 'Hold shipment at terminal delivery accessorial option',
  },
  accessorialGroceryConsolidationDelivery: {
    defaultMessage: 'Grocery Consolidation Delivery',
    id: 'z3ZNdw',
    description: 'Grocery consolidation delivery accessorial option',
  },
  accessorialAppointmentDelivery: {
    defaultMessage: 'Appointment Delivery',
    id: 'RB62kd',
    description: 'Appointment delivery accessorial option',
  },
  accessorialTradeshowDelivery: {
    defaultMessage: 'Tradeshow Delivery',
    id: 'l++btl',
    description: 'Tradeshow delivery accessorial option',
  },
  packagingPallet: {
    defaultMessage: 'Pallet',
    id: 'JqE1hx',
    description: 'Pallet packaging type option',
  },
  packagingBox: {
    defaultMessage: 'Box',
    id: 'RMnY7G',
    description: 'Box packaging type option',
  },
  packagingSkid: {
    defaultMessage: 'Skid',
    id: 'ZnudoW',
    description: 'Skid packaging type option',
  },
  packagingCrate: {
    defaultMessage: 'Crate',
    id: 'FwVQ5k',
    description: 'Crate packaging type option',
  },
  packagingBag: {
    defaultMessage: 'Bag',
    id: 'g5hjog',
    description: 'Bag packaging type option',
  },
  packagingBundle: {
    defaultMessage: 'Bundle',
    id: 'GdehlF',
    description: 'Bundle packaging type option',
  },
  packagingCarton: {
    defaultMessage: 'Carton',
    id: 'OGA3XJ',
    description: 'Carton packaging type option',
  },
  packagingDrum: {
    defaultMessage: 'Drum',
    id: '+8/wfZ',
    description: 'Drum packaging type option',
  },
  packagingBale: {
    defaultMessage: 'Bale',
    id: 'C5dbAZ',
    description: 'Bale packaging type option',
  },
  packagingCase: {
    defaultMessage: 'Case',
    id: 'wRDX8E',
    description: 'Case packaging type option',
  },
  packagingCylinder: {
    defaultMessage: 'Cylinder',
    id: 'ODo6bb',
    description: 'Cylinder packaging type option',
  },
  packagingPail: {
    defaultMessage: 'Pail',
    id: 'mMDglC',
    description: 'Pail packaging type option',
  },
  packagingPieces: {
    defaultMessage: 'Pieces',
    id: 'cJHqFq',
    description: 'Pieces packaging type option',
  },
  packagingReel: {
    defaultMessage: 'Reel',
    id: 'DKWMJh',
    description: 'Reel packaging type option',
  },
  packagingRoll: {
    defaultMessage: 'Roll',
    id: 'pruwP+',
    description: 'Roll packaging type option',
  },
  packagingTank: {
    defaultMessage: 'Tank',
    id: 'aUNLQy',
    description: 'Tank packaging type option',
  },
  packagingTote: {
    defaultMessage: 'Tote',
    id: '7tq3/d',
    description: 'Tote packaging type option',
  },
  packagingTrailer: {
    defaultMessage: 'Trailer',
    id: 'hcdJda',
    description: 'Trailer packaging type option',
  },
  packagingTube: {
    defaultMessage: 'Tube',
    id: 'RRp+8D',
    description: 'Tube packaging type option',
  },
  accessorialSortAndSegregate: {
    defaultMessage: 'Sort & Segregate',
    id: 'Xvawao',
    description: 'Sort and segregate accessorial option',
  },
  accessorialProtectFromFreezing: {
    defaultMessage: 'Protection From Cold',
    id: '9SHpZ7',
    description: 'Protection from cold/freezing accessorial option',
  },
  accessorialProtectionFromHeat: {
    defaultMessage: 'Protection From Heat',
    id: '9Zfejr',
    description: 'Protection from heat accessorial option',
  },
});
